import {
  CLAIM_STATUS_DISPLAY,
  ClaimStatusCodeEnum,
} from '../../HealthClaimPage/ClaimHandlingTable/types'
import { ClaimFormStatusTagStyle } from './styles'

const ClaimFormStatusTag = ({ status }: { status: ClaimStatusCodeEnum | string }) => {
  const label = CLAIM_STATUS_DISPLAY[status as ClaimStatusCodeEnum]

  return (
    <span style={{ display: 'inline-block', paddingLeft: '6px' }}>
      <ClaimFormStatusTagStyle status={status}>{label}</ClaimFormStatusTagStyle>
    </span>
  )
}

export default ClaimFormStatusTag
